import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FileService } from 'app/modules/common/services/file.service';
import { SharedService } from 'app/modules/common/services/shared-service';
import { FileFormatEnum } from 'app/modules/common/enums/file-format-enum';

@Component({
    selector: 'app-document-upload',
    templateUrl: './document-upload.component.html',
    styleUrls: ['./document-upload.component.scss'],
    standalone: false
})
export class DocumentUploadComponent implements OnInit {

    chosenFileName: string;

    @Output("fileChanges") fileChangeEvent = new EventEmitter<string>();

    @Input() title = "Documentación";

    public FileFormatEnum = FileFormatEnum;

    constructor(
        private fileService: FileService,
        private sharedService: SharedService
        //private fileFormatEnum: FileFormatEnum
    ) { }


    ngOnInit(): void { }


    /**
     * Listen for selected file changes
     */
    onFileChange(files: FileList) {

        if (files.length > 0) {
            this.readFile(files[0]);
        } else {
            this.removeFile();
        }
    }


    /**
     * Remove file name and raise file change event with  value
     */
    private removeFile() {
        this.chosenFileName = "";
        this.fileChangeEvent.emit(null);
    }


    /**
     * Read data of the given file and save in base 64 variable
     */
    private readFile(file: File) {
        const currentContext = this;
        const fileReader = new FileReader();

        fileReader.onload = function () {
            currentContext.chosenFileName = file.name;
            const base64Value = currentContext.fileService.arrayBufferToBase64(fileReader.result);
            currentContext.fileChangeEvent.emit(base64Value);
        };

        //if (this.fileService.getFileExtention(file.type) === "PDF") { 10/10/2023 Cambiar esta condicion mañana debe ir al revés. hay que comprobar si la extesión que viene está contenida en el enum
        if (FileFormatEnum.TrabajadorControllerDocumentoTS.includes(this.fileService.getFileExtention(file.type))) {
            fileReader.readAsArrayBuffer(file);
        } else {
            this.sharedService.ShowSnackBar("No se puede aceptar este tipo de archivo");
        }

    }

}
